import React from 'react';
import Controls from '../Controls/Controls';
import { useComponentProperties, useFormBuilderAttributes } from '../../../../Hooks/Display/useComponentProperties';

const ColumnContents = ({ column }) => {
    const [{ attributes }] = useFormBuilderAttributes();
    const [{ labelOrientation }] = useComponentProperties();

    const attribute = attributes.find((attr) => attr._id === column.attributeId);
    const dateTimeType = attribute.dateTimeType;
    const attributeType = attribute?.attributeType || 'default';

    const labelClass = labelOrientation === 'Top' ? 'col-12 form-buiider-label mb-1' : 'col-4 form-buiider-label mb-1';
    const containerClass = labelOrientation === 'Top' ? 'col-12 form-builder-control-container' : 'col-8 form-builder-control-container';

    return (
        <div className="form-group row h-100">
            <label className={labelClass} htmlFor="formGroupExampleInput" title={attribute?.attributeName}>
                {attribute?.attributeLabel}
            </label>
            <div className={containerClass}>
                <Controls type={attributeType} dateTimeType={dateTimeType} />
            </div>
        </div>
    );
};

export default ColumnContents;